<template>
  <li
    :class="[
      props.isDisabled ? 'pointer-events-none cursor-not-allowed' : '',
      props.onClick ? 'cursor-pointer' : 'cursor-default',
    ]"
    @click="handleClick"
    @keyup.prevent="handleClick"
  >
    <div class="flex gap-x-4 hover:bg-gray-100 px-4 py-4 sm:px-6">
      <img
        class="size-12 flex-none"
        :class="{ 'grayscale opacity-50': props.isDisabled }"
        :src="logo"
        :alt="`${title} logo`"
      >
      <div
        class="flex-auto"
        :class="{ 'opacity-50': props.isDisabled }"
      >
        <div class="flex items-baseline justify-between gap-x-4">
          <p
            class="text-sm/6 font-semibold"
            :class="props.isDisabled ? 'text-gray-500' : 'text-gray-900'"
          >
            {{ props.title }}
          </p>
          <p
            class="flex-none text-xs font-bold"
            :class="props.isDisabled ? 'text-gray-500' : 'text-gray-600'"
          >
            {{ props.availabilityText }}
          </p>
        </div>
        <p
          class="line-clamp-2 text-sm/6"
          :class="props.isDisabled ? 'text-gray-500' : 'text-gray-600'"
        >
          {{ props.description }}
        </p>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps({
  logo: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  availabilityText: {
    type: String, default: '',
  }, // "em breve" for upcoming features
  isDisabled: {
    type: Boolean,
    default: false,
  },
  onClick: {
    type: Function,
    default: null,
  },
});

const handleClick = () => {
  if (!props.onClick || props.isDisabled) return;
  props.onClick();
};
</script>
